import { projectsPagePath } from '@/pages/projects/ProjectsPage.shared';

export const projectDetailPagePath = projectsPagePath + '/:projectId';